import React from 'react';

import PropTypes from 'prop-types';

import * as S from './styles';

export default function ModalFilter({ inputs, formatter }) {
  return (
    <S.Wrapper>
      {inputs.map(({ id, type, label, options, autocomplete }) =>
        formatter(id, type, label, options, autocomplete)
      )}
    </S.Wrapper>
  );
}

ModalFilter.propTypes = {
  inputs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      label: PropTypes.string,
      options: PropTypes.arrayOf(PropTypes.any),
    })
  ).isRequired,
  formatter: PropTypes.func.isRequired,
};
